export default __webpack_public_path__ + "static/media/Creative.f7260eef.png";